import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

interface GetPackageRoomAccessCodeRequest {
  buildingId: number
}

interface GetPackageRoomAccessCodeResponse {
  code: string
}

export const getPackageRoomAccessCode = async (
  data: GetPackageRoomAccessCodeRequest,
): Promise<GetPackageRoomAccessCodeResponse> => {
  const response = await authAPI.post<GetPackageRoomAccessCodeResponse>(
    '/package-room/code-by-employee',
    data,
  )
  return response.data
}

export const useGetPackageRoomAccessCode = () => {
  return useMutation({
    mutationFn: getPackageRoomAccessCode,
  })
}
